import { IDeliveryZone } from '../_types';
import { request } from './http-client';

export const getCheckPointDeliveryZones = (params: any, shipperId?: string) =>
  request.get<{ result: IDeliveryZone[]; all_count: number }>(
    '/v1/check_point_delivery_zones',
    {
      params,
      headers: shipperId ? { Shipper: shipperId } : undefined,
    }
  );

export const getActiveDeliveryZones = (params: any, shipperId?: string) =>
  request.get('/v2/active-delivery-zones', {
    params,
    headers: shipperId ? { Shipper: shipperId } : undefined,
  });
